import * as React from "react";
import type { SVGProps } from "react";
const RulerPanelIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M8 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v19a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-.585h4v-1H8v-.846h2.154v-1H8v-.846h2.154v-1H8v-.846h4v-1H8v-.846h2.154v-1H8v-.846h2.154v-1H8v-.847h4v-1H8v-.846h2.154v-1H8v-.846h2.154v-1H8V4.3h4v-1H8z" clipRule="evenodd" /></svg>;
export default RulerPanelIcon;